import { StateType } from '..';

export const selectAnomalyStream = (store: StateType) => store.anomalies.anomalyStream;

export const selectFilters = (store: StateType) => store.anomalies.filters;

export const selectPagination = (store: StateType) => store.anomalies.pagination;
